import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root' // Rende il servizio disponibile ovunque nell'applicazione
})
export class UiNotificationService {
  // Iniettiamo il MessageService nativo di PrimeNG
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private translate = inject(TranslateService);

  // Metodi per Toast
  showSuccess(key: string) {
    const keysToTranslate = ['success', key];

    this.translate.get(keysToTranslate).subscribe((traduzioni) => {
      this.messageService.add({ key: 'tc', severity: 'success', summary: traduzioni['success'], detail: traduzioni[key] });
    });
  }

  showError(err: HttpErrorResponse) {
    let message: string = err.error !== null ? (typeof err.error === 'string' ? err.error : err.error.message) : err.message
    this.showErrorMessage(message);
  }

  showErrorMessage(key: string) {
    const keysToTranslate = ['error', key];

    this.translate.get(keysToTranslate).subscribe((traduzioni) => {
      this.messageService.add({ key: 'tc', severity: 'error', summary: traduzioni['error'], detail: traduzioni[key] });
    });
  }

  // Metodi per ConfirmDialog
  confirm(messageKey: string,
    onAccept: () => void,
    acceptButton: { labelKey: string; severity: string } = { labelKey: 'confirm', severity: 'danger' },
    headerKey: string = 'confirm',
    icon: string = 'pi-exclamation-triangle',
    messageParams: Object = {}) {

    const rejectLabelKey = 'primeng.cancel';
    const keysToTranslate = [messageKey, headerKey, acceptButton.labelKey, rejectLabelKey];

    this.translate.get(keysToTranslate, messageParams).subscribe((translations) => {
        this.confirmationService.confirm({
          message: translations[messageKey],
          header: translations[headerKey],
          icon: `pi ${icon}`,
          closable: false,
          closeOnEscape: false,
          rejectButtonProps: {
            label: translations[rejectLabelKey],
            severity: 'secondary',
            text: true
          },
          acceptButtonProps: {
            label: translations[acceptButton.labelKey],
            severity: acceptButton.severity
          },
          accept: onAccept,
          reject: () => {
            this.showErrorMessage('messages.cancelled')
          }
        });
    });
  }
}
